module.exports = __webpack_public_path__ + "img/sweden.d9bd6935.svg";